import { Route } from "react-router-dom";
import PublicLayout from "../layouts/PublicLayout";

import AgentListing from "../pages/public/AgentListing";
import AgentDetails from "../pages/public/AgentDetails";
import CompanyDetails from "../pages/public/CompanyDetails";
import Contact from "../pages/public/Contact";
import Home from "../pages/public/Home";
import Login from "../pages/public/Login";
import SuperAdminLogin from "../pages/super-admin/SuperAdminLogin";
import ExploreLocality from "../pages/public/ExploreLocality";
import NotFoundPage from "../pages/common/NotFoundPage";

import PostPropertyFormPage from "../pages/admin/post-properties/PostPropertyFormPage";
import PostPropertyLoginPage from "../pages/admin/post-properties/PostPropertyLoginPage";
import DetailsCommercialProperty from "../pages/public/property-details/DetailsCommercialProperty";
import DetailsLandProperty from "../pages/public/property-details/DetailsLandProperty";
import DetailsProjectProperty from "../pages/public/property-details/DetailsProjectProperty";
import DetailsResidentialProperty from "../pages/public/property-details/DetailsResidentialProperty";
import ListingAllProperties from "../pages/public/property-listings/ListingAllProperties";
import ListingCommercialProperties from "../pages/public/property-listings/ListingCommercialProperties";
import ListingLandProperties from "../pages/public/property-listings/ListingLandProperties";
import ListingProjectProperties from "../pages/public/property-listings/ListingProjectProperties";
import ComingSoonPage from "../pages/common/ComingSoonPage";

const PublicRoutes = [
  <Route key="public" path="/" element={<PublicLayout />}>
    <Route index element={<Home />} />
    <Route path="login" element={<Login />} />
    <Route path="contact" element={<Contact />} />
    <Route path="explore-locality" element={<ExploreLocality />} />
    <Route path="requested-properties" element={<ComingSoonPage />} />

    <Route path="post-property" element={<PostPropertyFormPage />} />
    <Route path="post-property-login" element={<PostPropertyLoginPage />} />

    <Route path="properties">
      <Route index element={<ListingAllProperties />} />

      <Route path="residential">
        <Route path=":id" element={<DetailsResidentialProperty />} />
      </Route>

      <Route path="land">
        <Route index element={<ListingLandProperties />} />
        <Route path=":id" element={<DetailsLandProperty />} />
      </Route>

      <Route path="commercial">
        <Route index element={<ListingCommercialProperties />} />
        <Route path=":id" element={<DetailsCommercialProperty />} />
      </Route>

      <Route path="project">
        {/* No listing page , create one */}
        <Route index element={<ListingProjectProperties />} />
        <Route path=":id" element={<DetailsProjectProperty />} />
      </Route>
    </Route>

    {/* ---------- Other  Pages ---------- */}
    <Route path="agents">
      <Route index element={<AgentListing />} />
      <Route path=":id" element={<AgentDetails />} />
    </Route>

    {/* <Route path="developer-details" element={<DeveloperDetails />} /> */}
    <Route path="company-details/:companyId" element={<CompanyDetails />} />

    {/* 404 catch-all */}
    <Route path="*" element={<NotFoundPage />} />
  </Route>,
  <Route key="super-admin-login" path="/super-admin/login" element={<SuperAdminLogin />} />,
];

export default PublicRoutes;

//AMAN'S

// import { Route } from "react-router-dom";
// import PublicLayout from "../layouts/PublicLayout";
// import Home from "../pages/public/Home";
// import Properties from "../pages/public/Properties";
// import Contact from "../pages/public/Contact";
// import Login from "../pages/public/Login";
// import PropertiesDetails from "../pages/public/PropertiesDetails";
// import AgentDetails from "../pages/public/AgentDetails";
// import FindAgent from "../pages/public/FindAgent";
// import DeveloperDetails from "../pages/public/DeveloperDetails";
// import LandDetails from "../pages/public/LandDetails";
// import Land from "../pages/public/Land";
// import CommercialProperty from "../pages/public/CommercialProperty";
// import ExploreLocality from "../pages/public/ExploreLocality";
// import CommercialPropertyDetails from "../pages/public/CommercialPropertyDetails";
// import Interior from "../pages/public/Interior";
// import ProjectDetails from "../pages/public/ProjectDetails";
// import PostPropertyLoginPage from "../pages/admin/post-properties/PostPropertyLoginPage";
// import PostPropertyFormPage from "../pages/admin/post-properties/PostPropertyFormPage";

// const PublicRoutes = [
//   <Route key="public" path="/" element={<PublicLayout />}>
//     {/* ----------> Normal Page <---------- */}
//     <Route index element={<Home />} />
//     <Route path="login" element={<Login />} />,
//     <Route path="properties" element={<Properties />} />
//     <Route path="land" element={<Land />} />
//     <Route path="commercial-property" element={<CommercialProperty />} />
//     <Route path="explore-locality" element={<ExploreLocality />} />
//     <Route path="contact" element={<Contact />} />
//     <Route path="find-agent" element={<FindAgent />} />
//     <Route path="interior" element={<Interior />} />
//     <Route path="post-property" element={<PostPropertyFormPage />} />
//     <Route path="post-property-login" element={<PostPropertyLoginPage />} />
//     {/* ----------> Details Page <---------- */}
//     <Route path="properties-details/:id" element={<PropertiesDetails />} />
//     <Route path="land-details/:id" element={<LandDetails />} />
//     <Route
//       path="commercial-property-details/:id"
//       element={<CommercialPropertyDetails />}
//     />
//     <Route path="project-details/:id" element={<ProjectDetails />} />
//     <Route path="agent-details" element={<AgentDetails />} />
//     <Route path="developer-details" element={<DeveloperDetails />} />
//     <Route path="project-details" element={<ProjectDetails />} />
//     {/* <Route path="land-details" element={<LandDetails />} /> */}
//     {/* <Route path="properties-details" element={<PropertiesDetails />} /> */}
//     {/* <Route
//       path="commercial-property-details"
//       element={<CommercialPropertyDetails />}
//     /> */}
//     {/* <Route path="project-details" element={<ProjectDetails />} /> */}
//   </Route>,
// ];

// export default PublicRoutes;
